<template>
  <div>

    <div class="card-body">
      <div class="tab-content">
        <div class="tab-pane active" id="activity">

          <div class="row">
            <div class="col-md-12">
              <h5 class="h4-t">Employee Allowed Leaves</h5>
              <hr />
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped table-sm">
                  <thead class="bg-info">
                    <tr>
                      <th>Leave Type</th>
                      <th>Year</th>
                      <th>Total Leaves</th>
                      <th style="width: 10px"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, ind) in leaves">
                      <td>{{item.Name}}</td>
                      <td>{{item.Year}}</td>
                      <td>{{item.TotalLeaves}}</td>
                      <td style="white-space: nowrap">
                        <button class="btn btn-sm btn-info" v-on:click="showLeavesModal(item, ind)"><i class="fas fa-edit"></i></button>
                        <button class="btn btn-sm btn-danger" data-toggle="modal" data-target="#modalDeleteLeaves" v-on:click="allowedLeaveIndex = ind;"><i class="fas fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="7">
                        <button class="btn btn-sm btn-secondary btn-block" type="button" v-on:click="showLeavesModal()">Add New</button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </div>


        </div>
      </div>
      <!-- /.tab-content -->
    </div>

    <div class="card-footer">
      <a class="btn btn-primary" href="../Employees/List">Back to List</a>
      <div class="float-right">
        <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" /> 
      </div>
    </div>

    <div class="modal fade" id="modalLeave">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Employee Leaves</h4>
          </div>

          <form id="contact" v-on:submit="saveLeave">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Leave Type *</label>
                    <select class="form-control" v-model="leave.LeaveTypeID" required>
                      <option value="" disabled>--Select--</option>
                      <option v-for="item in leaveType" :value="item.LeaveTypeID">{{item.LeaveTypeName}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Total Leaves *</label>
                    <input class="form-control" v-model="leave.TotalLeaves" required />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Year</label>
                    <input class="form-control" type="number" v-bind:max="maxYear" min="2020" v-model="leave.Year" required />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer justify-content-between">
              <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
              <button type="submit" class="btn btn-success">Save changes</button>
            </div>
          </form>

        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div class="modal fade" id="modalDeleteLeaves">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <h3>Are you sure you want to delete this record ?</h3>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" v-on:click="deleteLeave()" class="btn btn-danger">Delete</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>



  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
    },
    data() {
      return {
        leaves: [],
        leave: {
          EmployeeAllowedLeavesID: '',
          EmployeeID: '',
          LeaveTypeID: 0,
          TotalLeaves: 0,
          Year: ''
        },
        allowedLeaveIndex: -1,
        maxYear: 2022,


      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {

      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/EmployeesApi/pageLoadAllowedLeaves?id=' + vm.employeeId)
          .then(function (res) {
            endReq();

            vm.leaveType = res.data.leaveType;
            vm.maxYear = res.data.maxYear;

            if (res.data.leaves)
              vm.leaves = res.data.leaves;


          })
          .catch(function (error) {
            console.log(error);
          });
      },

      showLeavesModal(data, index) {
        if (data) {
          this.leave = Object.assign({}, data);
          this.allowedLeaveIndex = index
        }
        else {
          this.leave = {

            EmployeeAllowedLeavesID: '',
            EmployeeID: '',
            LeaveTypeID: 0,
            TotalLeaves: 0,
            Year: ''
          };
          this.allowedLeaveIndex = -1;
        }

        $('#modalLeave').modal('show');
      },

      saveLeave(e) {
        e.preventDefault();
        var vm = this;
        startReq();
        axios.post('/api/EmployeesApi/saveLeave?id=' + vm.employeeId, {
          leave: vm.leave
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Saved Successfully", "Done");
              if (vm.allowedLeaveIndex == -1)
                vm.leaves.push(res.data.leave);
              else {
                vm.leaves[vm.allowedLeaveIndex] = res.data.leave;
                vm.allowedLeaveIndex = -1;
                $('#modalLeave').modal('hide');
              }

              vm.leave = {
                EmployeeAllowedLeavesID: '',
                EmployeeID: '',
                LeaveTypeID: 0,
                TotalLeaves: 0,
                Year: ''
              };
            }
            else
              toastr.error(res.data.msg);

          }).catch(function (err) {
            endReq();
            var res = err.response;
            if (res.status == 401) {
              toastr.error(res.data);
            }
            else {
              for (const [key, value] of Object.entries(res.data.errors)) {
                toastr.error(`${value}`);
              }
            }
          })
      },

      deleteLeave() {
        var vm = this;
        startReq();
        axios.get('/api/EmployeesApi/deleteLeave?id=' + vm.leaves[vm.allowedLeaveIndex].EmployeeAllowedLeavesID)
          .then(function (res) {
            endReq();
            if (res.data.status) {
              toastr.success("Deleted Successfully", "Done!");
              vm.leaves.splice(vm.allowedLeaveIndex, 1);
              vm.allowedLeaveIndex = -1;
              $('#modalDeleteLeaves').modal('hide');
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }, 

      clear() {
        this.emp = {
          OldEmpCode: '',
          EmpCode: '',
          SrName: 'Mr.',
          Name: '',
          FatherName: '',
          GenderID: '',
          DateOfBirth: '',
          CNIC: '',
          Detail: { BloodGroup: '', ReligionID: 1, NationalityID: 1, Nationality2: 0, MaritalStatus: '' }
        };
        this.img = '';
        this.sendEmp(null);
        this.sendImg('');
        $('#name').focus();
      }

    }
  })</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/hr/employeeAllowedLeaves.vue